import React from 'react'
import { Table, PageHeader } from 'antd'

const dataSource = langSlug => [
    {
        class: 'img-lazy',
        description:
            langSlug == 'th'
                ? 'ใช้กับแท็ก <img/> เพื่อให้รูปโหลดเมื่อ scroll ไปถึง'
                : 'Use with <img/> tag to make the image load when the scroll reaches it'
    },
    {
        class: 'column-no-header',
        description:
            langSlug == 'th' ? 'ซ่อนส่วนหัวของคอลัมน์' : 'Hide column header'
    },
    {
        class: 'theme-text-light',
        description:
            langSlug == 'th'
                ? 'เปลี่ยนหัวข้อเป็นสีขาว'
                : 'Change title color to white'
    },
    {
        class: 'theme-column-header-text-light',
        description:
            langSlug == 'th'
                ? 'เปลี่ยนเฉพาะหัวข้อคอลัมน์เป็นสีขาว'
                : 'Change column title color to white'
    },
    {
        class: 'theme-text-dark',
        description:
            langSlug == 'th'
                ? 'เปลี่ยนหัวข้อเป็นสีดำ'
                : 'Change title color to black'
    },
    {
        class: 'theme-column-header-text-dark',
        description:
            langSlug == 'th'
                ? 'เปลี่ยนเฉพาะหัวข้อคอลัมน์เป็นสีดำ'
                : 'Change column title color to black'
    },
    {
        class: 'product-cards-no-border',
        description:
            langSlug == 'th'
                ? 'ซ่อนเส้นขอบของการ์ดสินค้าและเปลี่ยนพื้นหลังเป็นโปร่งใส'
                : 'Hide product cards border and change background to transparent'
    },
    {
        class: 'product-cards-no-border-only',
        description:
            langSlug == 'th'
                ? 'ซ่อนแค่เส้นขอบของการ์ดสินค้าเท่านั้น'
                : 'Hide product cards border only'
    },
    {
        class: 'product-cards-no-rating',
        description:
            langSlug == 'th'
                ? 'ซ่อนดาวเรทติ้งของการ์ดสินค้า'
                : 'Hide product cards rating stars'
    },
    {
        class: 'product-cards-text-center',
        description:
            langSlug == 'th'
                ? 'ทำให้ตัวอักษรของการ์ดสินค้าอยู่กึ่งกลาง'
                : 'Set product cards text to be center'
    },
    {
        class: 'post-cards-no-border',
        description:
            langSlug == 'th'
                ? 'ซ่อนเส้นขอบของการ์ดบทความและเปลี่ยนพื้นหลังเป็นโปร่งใส'
                : 'Hide article cards border and change background to transparent'
    },
    {
        class: 'post-cards-no-border-only',
        description:
            langSlug == 'th'
                ? 'ซ่อนแค่เส้นขอบของการ์ดบทความเท่านั้น'
                : 'Hide article cards border only'
    },
    {
        class: 'post-cards-category-tags',
        description:
            langSlug == 'th'
                ? 'ซ่อนแท็กหมวดหมู่บนการ์ดบทความ'
                : 'Hide category tags on product cards'
    },
    {
        class: 'post-cards-text-center',
        description:
            langSlug == 'th'
                ? 'ทำให้ตัวอักษรของการ์ดบทความอยู่กึ่งกลาง'
                : 'Set article cards text to be center'
    },
    {
        class: 'pr-[0, 1, 2, 3, 4, 5]',
        description:
            langSlug == 'th'
                ? 'ระยะห่างขอบด้านขวาในทุกขนาดหน้าจอ'
                : 'Padding right on every screen size'
    },
    {
        class: 'pl-[0, 1, 2, 3, 4, 5]',
        description:
            langSlug == 'th'
                ? 'ระยะห่างขอบด้านซ้ายในทุกขนาดหน้าจอ'
                : 'Padding left on every screen size'
    },
    {
        class: 'pr-[md, lg]-[0, 1, 2, 3, 4, 5]',
        description:
            langSlug == 'th'
                ? 'ระยะห่างขอบด้านขวาในขนาดหน้าจอ แท็บเล็ต(md) และเดสก์ท็อป(lg)'
                : 'Padding right on screen any screen size - tablet(md) and desktop(lg)'
    },
    {
        class: 'pl-[md, lg]-[0, 1, 2, 3, 4, 5]',
        description:
            langSlug == 'th'
                ? 'ระยะห่างขอบด้านซ้ายในขนาดหน้าจอ แท็บเล็ต(md) และเดสก์ท็อป(lg)'
                : 'Padding left on screen any screen size - tablet(md) and desktop(lg)'
    },
    {
        class: 'd-none',
        description:
            langSlug == 'th'
                ? 'ซ่อนวัตถุในทุกขนาดหน้าจอ'
                : 'Hide object on all screen size'
    },
    {
        class: 'd-none d-md-block',
        description:
            langSlug == 'th'
                ? 'ซ่อนวัตถุในขนาดหน้าจอมือถือเท่านั้น'
                : 'Hide object only on mobile screen size'
    },
    {
        class: 'd-md-none d-lg-block',
        description:
            langSlug == 'th'
                ? 'ซ่อนวัตถุในขนาดหน้าจอแท็บเล็ตเท่านั้น'
                : 'Hide object only on tablet screen size'
    },
    {
        class: 'd-lg-none',
        description:
            langSlug == 'th'
                ? 'ซ่อนวัตถุในขนาดหน้าจอเดสก์ท็อปเท่านั้น'
                : 'Hide object only on desktop screen size'
    }
]

const columns = T => [
    {
        title: 'Class',
        dataIndex: 'class',
        key: 'class'
    },
    {
        title: T('DESCRIPTION'),
        dataIndex: 'description',
        key: 'description'
    }
]

const AvailableClasses = ({ T, langSlug }) => {
    return (
        <div>
            <PageHeader backIcon={false} title="Built-in CSS Classes" />
            <Table
                dataSource={dataSource(langSlug)}
                columns={columns(T)}
                bordered
            />
        </div>
    )
}

export default AvailableClasses
